import React, { useState } from 'react'
import styles from './HomeFAQSection.module.css'

const FAQS = [
  {
    q: 'How far in advance should we engage you for an event?',
    a: 'For conferences and large-scale events we recommend 8–12 weeks, though we regularly take on faster timelines. The earlier we begin, the more strategy and creative depth we can build into the experience.',
  },
  {
    q: 'Do you offer customisable packages?',
    a: 'Always. Every engagement is tailored — we immerse ourselves in your objectives and design the scope, format, and budget around them, backed by a clear cost-benefit analysis.',
  },
  {
    q: 'Do you work with our vendors or bring your own?',
    a: 'Both. We have a trusted production and supplier network across India, and we are equally happy to work with your preferred vendors or co-create the roster with you.',
  },
  {
    q: 'Do you handle on-the-day coordination?',
    a: 'Yes. Our team is on-ground from setup to wrap, managing every stage cue, logistic, and guest moment — so you can focus on your people, not the run-sheet.',
  },
  {
    q: 'Do you manage events across India?',
    a: 'We do. We have delivered experiences across 22 cities and handle end-to-end logistics for leadership off-sites, incentive travel, and destination conferences.',
  },
  {
    q: 'What does your strategic consulting involve?',
    a: 'Strategy is core to how we work. We provide tailored strategies, risk analysis, and cost-benefit modelling — then continue to monitor, evaluate, and refine after execution.',
  },
]

const HomeFAQSection = ({ faqs = FAQS }) => {
  const [open, setOpen] = useState(null)

  const toggle = (i) => setOpen(open === i ? null : i)

  return (
    <section className={styles.section}>
      <div className={styles.container}>
        {/* Left */}
        <div className={styles.head}>
          <span className={styles.eyebrow}>Frequently Asked Questions</span>
          <h2 className={styles.heading}>
            The most common questions about our services, processes, and more
          </h2>
        </div>

        {/* Right — accordion */}
        <div className={styles.list}>
          {faqs.map((item, i) => {
            const isOpen = open === i
            return (
              <div key={i} className={`${styles.item} ${isOpen ? styles.itemOpen : ''}`}>
                <button
                  className={styles.question}
                  onClick={() => toggle(i)}
                  aria-expanded={isOpen}
                >
                  <span>{item.q}</span>
                  <span className={styles.icon} aria-hidden="true">
                    <span className={styles.iconBar} />
                    <span className={`${styles.iconBar} ${styles.iconBarV}`} />
                  </span>
                </button>

                <div className={styles.panel}>
                  <div className={styles.panelInner}>
                    <p className={styles.answer}>{item.a}</p>
                  </div>
                </div>
              </div>
            )
          })}
        </div>
      </div>
    </section>
  )
}

export default HomeFAQSection